__webpack_require__.p = "/www/hosting/balonklub.cz/www/wp-content/reactpress/apps/balonklub-cli/build/";